module.exports = __webpack_public_path__ + "static/media/programa_publico_Veronica.f637b6c1.jpg";